import { useEffect, useRef, useState } from "react";

export const usePlaceAutocomplete = (language: "en" | "ar") => {
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState<
    google.maps.places.AutocompletePrediction[]
  >([]);
  const [isEditing, setIsEditing] = useState(false);

  const serviceRef =
    useRef<google.maps.places.AutocompleteService | null>(null);

  useEffect(() => {
   if (
  window.google &&
  window.google.maps &&
  window.google.maps.places
) {
  serviceRef.current =
    new window.google.maps.places.AutocompleteService();
}
  }, []);

  useEffect(() => {
    if (!isEditing || query.length < 3 || !serviceRef.current) {
      setSuggestions([]);
      return;
    }

    const timer = setTimeout(() => {
      serviceRef.current!.getPlacePredictions(
        {
          input: query,
          types: ["(cities)"],
          language,
        },
        (predictions) => setSuggestions(predictions || [])
      );
    }, 300);

    return () => clearTimeout(timer);
  }, [query, isEditing, language]);

  const selectPlace = (
    placeId: string,
    cb: (address: string) => void
  ) => {
    const service = new window.google.maps.places.PlacesService(
      document.createElement("div")
    );

    service.getDetails(
      {
        placeId,
        fields: ["name", "formatted_address"],
        language,
      },
      (place) => {
        const address =
          place?.formatted_address || place?.name || "";
        cb(address);
        setSuggestions([]);
        setIsEditing(false);
      }
    );
  };

  return {
    query,
    setQuery,
    suggestions,
    isEditing, 
    setIsEditing,
    selectPlace,
  };
};
